export default __webpack_public_path__ + "static/media/placeholder_dummy2016-baeckerei01-de.70a9ff74.png";